import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import useClient from "../../api/hooks/useClients";
import ClientsTable from "../../components/client/ClientsTable";
import LogMessage from "../../components/misc/LogMessage";
import NavBar from "../../components/misc/NavBar";
import SearchBar from "../../components/misc/Searcbar";
import SideBar from "../../components/misc/SideBar";
import ClientCreateModal from "../../components/modals/ClientCreateModal";
import { logMsgBgColors } from "../../consts/misc";
import { toIcons } from "../../consts/Paths";
import useIsMobile from "../../hooks/useIsMobile";
import useLogMessage from "../../hooks/useLogMessage";
import useToggle from "../../hooks/useToggle";
import { Client } from "../../interfaces";
import "../../styles/Clients.css";

const ClientsPage = (props: any) => {
  const { isMobile } = useIsMobile();
  const { RESPONSES, RESULTS, CTAs } = useClient();
  const logMessage = useLogMessage();
  const resetListToggler = useToggle(false);
  const menuToggler = useToggle(false);
  const toggleNewClientModal = useToggle(false);

  const onSearchForm = useForm();
  const newClientForm = useForm();

  const [clientOnSearchName, setClientOnSearchName] = useState("");

  const loadMoreToggler = useToggle(false);
  const [loadMoreCounter, setLoadMoreCounter] = useState<number>(1);

  const tempLoading = useToggle(false);

  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    const url = new URL(window.location.href);
    const isEmpty = url.searchParams.get("empty");
    if (isEmpty) {
      setIsEmpty(true);
    } else setIsEmpty(false);
  }, []);

  useEffect(() => {
    if (isEmpty) {
      toggleNewClientModal.setIsToggled(true);
    }
  }, [isEmpty]);

  useEffect(() => {
    if (tempLoading.isToggled) {
      /* caricamento */
      logMessage.setMessageTimer(20000);
      logMessage.write("subject", "Loading . . .");
      logMessage.write("bgColor", logMsgBgColors.loading);
    } else if (!tempLoading.isToggled) {
      logMessage.setMessageTimer(null);
    }
  }, [tempLoading.isToggled]);

  const onClientSearch = (data: any) => {
    setClientOnSearchName(data.name);
  };

  useEffect(() => {
    /*  console.log(RESPONSES.createResponse, RESULTS.createResult); */
    if (RESPONSES.createResponse?.ok) {
      tempLoading.setIsToggled(false);
      logMessage.write("subject", "Client");
      logMessage.write("other_text", " addedd succeessfully!");
      logMessage.write("bgColor", logMsgBgColors.correct);
      toggleNewClientModal.toggle();
      resetListToggler.toggle();
    } else if (RESPONSES.createResponse?.ok === false) {
      tempLoading.setIsToggled(false);
      logMessage.write("subject", "Client");
      logMessage.write("other_text", " could not be deleted");
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [RESPONSES.createResponse]);

  const onNewClientSubmit = (data: any) => {
    tempLoading.setIsToggled(true);

    let finalObj = {};
    const final = Object.entries(data).filter((o) => o[1] != "");

    final.forEach((keyvalue: any) => {
      let property: object = {};
      property = { [keyvalue[0]]: keyvalue[1] };
      finalObj = { ...finalObj, ...property };
    });

    CTAs.createClient(finalObj);
  };

  return (
    <div className="page-wrapper is-hidden is-visuallyHidden">
      <form onSubmit={newClientForm.handleSubmit(onNewClientSubmit)}>
        {toggleNewClientModal.isToggled && (
          <ClientCreateModal
            toggler={toggleNewClientModal}
            register={newClientForm.register}
            errors={newClientForm.formState.errors}
            logMessage={logMessage}
          />
        )}
      </form>
      {(!isMobile || menuToggler.isToggled) && (
        <SideBar toggler={menuToggler} />
      )}
      <div>
        {isMobile && <NavBar toggler={menuToggler} />}
        <div
          className={`page-content ${
            isMobile && menuToggler.isToggled
              ? menuToggler.isToggledSecondary
                ? "slide-right"
                : "slide-left"
              : ""
          }`}
          style={{
            maxWidth: isMobile ? "" : "calc(100vw - 256px)",
            minWidth: isMobile ? "" : "1105px",
            marginLeft: isMobile
              ? menuToggler.isToggled
                ? "256px"
                : ""
              : "256px",
            display: toggleNewClientModal.isToggled && isMobile ? "none" : "",
          }}
        >
          {logMessage.isToggled && (
            <LogMessage
              text={{
                subject: logMessage.message.subject,
                other_text: logMessage.message.other_text,
                complement: logMessage.message.complement,
              }}
              bgColor={logMessage.message.bgColor}
            />
          )}
          <div
            className="header-box"
            style={{
              width: isMobile ? "345px" : "",
            }}
          >
            <p className={isMobile ? `titlePage-Mob` : `titlePage`}>Clients</p>
            {/*  <SearchBar notify={true} /> */}
          </div>
          <div
            className="clients-table-box shadow"
            style={{
              width: isMobile ? "345px" : "",
              margin: isMobile ? "0 16px 0" : "",
            }}
          >
            <div
              className="search-box-content"
              style={{
                margin: isMobile ? "32px 21px 0" : "",
                justifyContent: isMobile ? "space-between" : "",
              }}
            >
              <form onChange={onSearchForm.handleSubmit(onClientSearch)}>
                <SearchBar
                  notify={false}
                  width={isMobile ? 170 : 332}
                  iconShift={isMobile ? 20 : 11}
                  register={onSearchForm.register}
                />
              </form>
              <button
                className="add-button"
                type="button"
                onClick={toggleNewClientModal.toggle}
                style={{
                  width: isMobile ? "56px" : "",
                }}
              >
                <img className="white" src={`${toIcons}/plus.svg`} />
                {!isMobile && <p className="add-buttonText">New Client</p>}
              </button>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <ClientsTable
                clientOnSearchName={clientOnSearchName}
                resetToggler={resetListToggler}
                loadMoreToggler={loadMoreToggler}
                loadMoreCounter={loadMoreCounter}
              />
              {/*  {!loadMoreToggler.isToggled && (
                <div style={{ marginTop: "40px", marginBottom: "40px" }}>
                  <button
                    className="button2"
                    type="button"
                    onClick={() => {
                      setLoadMoreCounter((prevCounter) => prevCounter + 1);
                    }}
                  >
                    <p className="button2-text">Load More</p>
                  </button>
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ClientsPage;
